import Vue from 'vue';
export default Vue.extend({
    props: {
        title: {
            type: String,
            default: '',
        },
        value: {
            type: Number,
            default: 0,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        maxValue: {
            type: Number,
        },
        minValue: {
            type: Number,
            default: 0,
        },
        disabledQuantityButton: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        selectedValue() {
            let next = this.value;
            // if (next < this.minValue) {
            //   next = this.minValue;
            // }
            if (this.maxValue != null && next > this.maxValue) {
                next = this.maxValue;
            }
            return next;
        },
    },
    methods: {
        onInput(e, maxValueStock) {
            const el = e.target;
            // parse current typed text
            let next = Number.parseInt(el.value, 10);
            if (!Number.isFinite(next))
                next = 0;
            // clamp
            next = Math.max(0, next);
            if (maxValueStock != null && maxValueStock !== 0) {
                next = Math.min(next, maxValueStock);
            }
            // IMPORTANT: force the DOM value to the clamped value immediately
            if (el.value !== String(next)) {
                el.value = String(next);
            }
            this.$emit('input', next);
        },
        // keep your existing emitChange if you want for +/- buttons
        emitChange(quantity, maxValueStock) {
            if (maxValueStock != null && maxValueStock != 0) {
                if (quantity <= maxValueStock) {
                    this.$emit('input', quantity);
                }
            }
            else {
                this.$emit('input', quantity);
            }
        },
    },
});
